export * from './avantio-label';
